module.exports = __webpack_public_path__ + "img/LOGO@3x.1fd9eb58.png";